

import hooks from '../../actions/hooks';
import { setMessages } from './index';


export const fetchMessages = (token) => async (dispatch) => {
    try {
        const messages = await hooks.get('/get/messages', token);
        dispatch(setMessages(messages || []));
    } catch (error) {
        console.error("\txx error fetching messages:", error);
    }
};

export const deleteMessage = (message_id, token) => async (dispatch, getState) => {
    try {
        await hooks.delete('/messages/one', message_id, token);
        const remaining = getState().messages.data.filter(m => m.message_id !== message_id);
        dispatch(setMessages(remaining));
    } catch (error) {
        console.error("\txx error deleting message:", error);
    }
};

export const deleteAllMessages = (token) => async (dispatch) => {
    try {
        await hooks.delete('/messages/all', null, token);
        dispatch(setMessages([]));
    } catch (error) {
        console.error("\txx error deleting all messages:", error);
    }
};